(() => {
  'use strict';

  const announce = (message) => {
    const region = document.getElementById('GlobalStatus');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(() => { region.textContent = message; }, 40);
  };

  const getFocusable = (container) => [...container.querySelectorAll(
    'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
  )].filter((element) => !element.hidden && element.offsetParent !== null);

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-quantity-button]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('[data-quantity]');
      const input = wrapper?.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(input.step || 1);
      const min = Number(input.min || 1);
      const max = input.max ? Number(input.max) : Infinity;
      const next = quantityButton.dataset.quantityButton === 'increase'
        ? Math.min(max, Number(input.value || min) + step)
        : Math.max(min, Number(input.value || min) - step);
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      announce(`Menge: ${next}`);
    }

    const privacyButton = event.target.closest('[data-cookie-preferences]');
    if (privacyButton) {
      event.preventDefault();
      if (window.Shopify?.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
        window.Shopify.customerPrivacy.showPreferences();
      } else if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      } else {
        window.location.href = privacyButton.dataset.fallback || '/policies/privacy-policy';
      }
    }
  });

  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    const openButton = menu.querySelector('[data-mobile-open]');
    const closeButton = menu.querySelector('[data-mobile-close]');
    const panel = menu.querySelector('[data-mobile-panel]');
    if (!openButton || !closeButton || !panel) return;

    const openMenu = () => {
      panel.hidden = false;
      document.body.classList.add('menu-open');
      openButton.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => {
        const focusable = getFocusable(panel);
        (focusable[0] || closeButton).focus();
      }, 20);
    };

    const closeMenu = () => {
      panel.hidden = true;
      document.body.classList.remove('menu-open');
      openButton.setAttribute('aria-expanded', 'false');
      openButton.focus();
    };

    openButton.addEventListener('click', openMenu);
    closeButton.addEventListener('click', closeMenu);

    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = getFocusable(panel);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const buttons = [...gallery.querySelectorAll('[data-gallery-button]')];
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];

    const activate = (index, announceChange = true) => {
      slides.forEach((slide) => {
        const active = slide.dataset.gallerySlide === String(index);
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      buttons.forEach((button) => {
        const active = button.dataset.galleryButton === String(index);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (announceChange) announce(`Produktbild ${Number(index) + 1} wird angezeigt.`);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => activate(button.dataset.galleryButton));
    });

    gallery.activateByImageId = (imageId) => {
      const slide = slides.find((item) => item.dataset.imageId === String(imageId));
      if (slide) activate(slide.dataset.gallerySlide, false);
    };
  });

  document.querySelectorAll('[data-product-scope]').forEach((scope) => {
    const select = scope.querySelector('[data-variant-select]');
    if (!select) return;
    const price = scope.querySelector('[data-product-price]');
    const compare = scope.querySelector('[data-product-compare]');
    const button = scope.querySelector('[data-add-to-cart]');
    const gallery = scope.querySelector('[data-product-gallery]');
    const optionInputs = [...scope.querySelectorAll('.product-option__input')];

    const updateFromSelect = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = option.dataset.compareVisible !== 'true';
      }
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableText : button.dataset.soldOutText;
      }
      if (gallery?.activateByImageId && option.dataset.imageId) {
        gallery.activateByImageId(option.dataset.imageId);
      }
    };

    const findVariantFromInputs = () => {
      const values = [...scope.querySelectorAll('[data-product-option]')].map((fieldset) => {
        return fieldset.querySelector('.product-option__input:checked')?.value;
      });
      const matching = [...select.options].find((option) => {
        try {
          const variantOptions = JSON.parse(option.dataset.options || '[]');
          return variantOptions.length === values.length && variantOptions.every((value, index) => value === values[index]);
        } catch (_error) {
          return false;
        }
      });
      if (!matching) return;
      select.value = matching.value;
      updateFromSelect();
    };

    optionInputs.forEach((input) => input.addEventListener('change', findVariantFromInputs));
    select.addEventListener('change', updateFromSelect);
    updateFromSelect();
  });

  document.querySelectorAll('.withdrawal-form').forEach((form) => {
    const stepOne = form.querySelector('[data-withdrawal-step="1"]');
    const stepTwo = form.querySelector('[data-withdrawal-step="2"]');
    const nextButton = form.querySelector('[data-withdrawal-next]');
    const backButton = form.querySelector('[data-withdrawal-back]');
    const timestamp = form.querySelector('[data-submitted-at]');
    const summary = form.querySelector('[data-withdrawal-summary]');
    const stepIndicators = [...form.closest('.legal-card')?.querySelectorAll('[data-step-indicator]') || []];

    const setStep = (step) => {
      const second = step === 2;
      if (stepOne) stepOne.hidden = second;
      if (stepTwo) stepTwo.hidden = !second;
      stepIndicators.forEach((indicator) => indicator.classList.toggle('is-active', indicator.dataset.stepIndicator === String(step)));
      const focusTarget = second ? stepTwo?.querySelector('h2,button,input') : stepOne?.querySelector('input,button');
      focusTarget?.focus();
    };

    const getFieldValue = (selector) => form.querySelector(selector)?.value?.trim() || '';

    nextButton?.addEventListener('click', () => {
      const requiredFields = [...stepOne.querySelectorAll('[required]')];
      const invalid = requiredFields.find((field) => !field.checkValidity());
      if (invalid) {
        invalid.reportValidity();
        invalid.focus();
        return;
      }
      if (summary) {
        summary.innerHTML = '';
        const items = [
          ['Name', getFieldValue('[name="contact[name]"]')],
          ['E-Mail', getFieldValue('[name="contact[email]"]')],
          ['Bestellnummer', getFieldValue('[name="contact[Order number]"]')],
          ['Betroffene Produkte', getFieldValue('[name="contact[Products]"]')]
        ];
        items.forEach(([label, value]) => {
          const li = document.createElement('li');
          const strong = document.createElement('strong');
          strong.textContent = `${label}: `;
          li.append(strong, document.createTextNode(value));
          summary.appendChild(li);
        });
      }
      setStep(2);
    });

    backButton?.addEventListener('click', () => setStep(1));

    form.addEventListener('submit', () => {
      if (timestamp) timestamp.value = new Date().toISOString();
    });
  });
})();
